export enum SiteActionAPIResponse {
  Update = 'update',
  Review = 'review',
  Sold = 'sold',
  New = 'new',
  Ignore = 'ignore',
}
